export default class OrganizationThemeService {
	static parseGradientString(gradientString: string): [string, string] {
		const lineGradientColors = gradientString
			.replace(
				/linear-gradient\(90deg, (#[a-fA-F0-9]{6}) [0-9]+%, (#[a-fA-F0-9]{6}) [0-9]+%\);*/,
				'$1|$2',
			)
			.split('|');

		return [lineGradientColors[0], lineGradientColors[1]];
	}
}
